/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Unit of measure enumeration for time. Supported values are:
 * - h (hour)
 * - min (minute)
 * - s (second)
 *
 */
export var TimeUomEnum;
(function (TimeUomEnum) {
    TimeUomEnum["H"] = "h";
    TimeUomEnum["MIN"] = "min";
    TimeUomEnum["S"] = "s";
})(TimeUomEnum || (TimeUomEnum = {}));
